var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.06844 5.21297C7.46143 5.21297 7.6145 4.9868 7.41166 4.70962L4.11901 0.208199C3.91566 -0.0698131 3.58535 -0.0689875 3.3825 0.208199L0.0898436 4.70962C-0.113509 4.98763 0.0399149 5.21297 0.433228 5.21297H7.06844ZM0.433368 6.78674C0.0402195 6.78674 -0.11286 7.01309 0.0899844 7.29028L3.38264 11.7917C3.58599 12.0698 3.91629 12.069 4.11915 11.7917L7.4118 7.29028C7.61515 7.01227 7.46173 6.78674 7.06858 6.78674H0.433368Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.523918c4a4a9d74b8b2929c7d6c4c810.svg";
export { ForwardRef as ReactComponent };